/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyTagCreateUpdateRequest } from '../../models/company-tag-create-update-request';
import { CompanyTagDto } from '../../models/company-tag-dto';

export interface CreateCompanyTag$Params {
      body: CompanyTagCreateUpdateRequest
}

export function createCompanyTag(http: HttpClient, rootUrl: string, params: CreateCompanyTag$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyTagDto>> {
  const rb = new RequestBuilder(rootUrl, createCompanyTag.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyTagDto>;
    })
  );
}

createCompanyTag.PATH = '/api/company/tags';
